import React, { useState, useEffect } from 'react';
import { func } from 'prop-types';
import {
  ButtonGroup,
  Button,
  Slide,
  Typography,
} from '@material-ui/core';
import {
  ThumbDown,
  ThumbUp,
} from '@material-ui/icons';

import {
  withMeetingContext,
  MeetingContextMeetingControlsProps,
} from 'Scenes/_root/meetingContext';
import styles from './styles.scss';

const MeetingFeedback = ({
  registerMeetingCallbacks,
  openMeetingFeedbackModal,
  meetingControls,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const onSubmittedFeedback = () => {
    setIsOpen(false);
    meetingControls.dismissFeedback();
  };

  const submitPositiveFeedback = () => {
    meetingControls.submitFeedback('NA', true);
  };

  useEffect(() => {
    window.setTimeout(() => {
      setIsOpen(true);
    }, 5 * 1000);
    return registerMeetingCallbacks('meetingFeedback', {
      onSubmittedFeedback,
    });
  }, []);

  return (
    <div className={styles.meetingFeedbackWrapper}>
      <Slide
        appear
        direction='down'
        in={isOpen}
        timeout={{
          enter: 225,
          exit: 195,
        }}
      >
        <div className={styles.meetingFeedback}>
          <Typography
            color='secondary'
            variant='body1'
          >
            Is your call working as expected?
          </Typography>
          <ButtonGroup
            fullWidth
            color='secondary'
            size='small'
          >
            <Button onClick={submitPositiveFeedback}>
              <ThumbUp />
            </Button>
            <Button onClick={openMeetingFeedbackModal}>
              <ThumbDown />
            </Button>
          </ButtonGroup>
        </div>
      </Slide>
    </div>
  );
};

MeetingFeedback.propTypes = {
  openMeetingFeedbackModal: func.isRequired,
  registerMeetingCallbacks: func.isRequired,
  meetingControls: MeetingContextMeetingControlsProps,
};

export default withMeetingContext(['registerMeetingCallbacks', 'meetingControls'])(MeetingFeedback);
